import axios from 'axios';

export const handleAxiosError = (error: any, defaultMessage: string) => {
  if (axios.isAxiosError(error) && error.response) {
    console.error(defaultMessage, error.response.data.error || error.message);
    throw new Error(error.response.data.error || defaultMessage);
  } else {
    console.error(defaultMessage, error.message);
    throw new Error(error.message || "An error occurred");
  }
};